module.exports = __webpack_public_path__ + "img/2471.1be29672.jpg";